import { Crown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { CustomerTierFragment } from "@/gql/graphql";
import { cn } from "@/lib/utils";
import { ColorUtils } from "@/lib/utils/color-utils";

interface TierBadgeProps {
  tier: CustomerTierFragment | null | undefined;
  size?: "sm" | "md";
  showPriorityIcon?: boolean;
  className?: string;
}

export function TierBadge({
  tier,
  size = "sm",
  showPriorityIcon = true,
  className,
}: TierBadgeProps) {
  if (!tier) {
    return null;
  }

  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-3 py-1",
  };

  const iconSize = size === "sm" ? "h-3 w-3" : "h-4 w-4";

  // Use enhanced color utilities for better accessibility
  const colorStyle = ColorUtils.getTierColorStyle(tier.color, 0.3); // Increased opacity from 15% to 30%

  return (
    <Badge
      variant="secondary"
      className={cn(sizeClasses[size], "font-medium border", colorStyle.className, className)}
      style={colorStyle.style}
    >
      <span className="flex items-center gap-1">
        {showPriorityIcon && tier.priorityBooking && (
          <Crown className={cn(iconSize, "flex-shrink-0")} />
        )}
        {tier.name}
      </span>
    </Badge>
  );
}
